export const userTypes = {
    SIGN_IN_START: 'SIGN_IN_START',
    SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
    SIGN_IN_FAILED: 'SIGN_IN_FAILED',
    SIGN_IN_END: 'SIGN_IN_END',

    SET_USER: 'SET_USER',
    LOGOUT_USER: 'LOGOUT_USER',

    VERIFY_NUMBER_START: 'VERIFY_NUMBER_START',
    VERIFY_NUMBER_SUCCESS: 'VERIFY_NUMBER_SUCCESS',
    VERIFY_NUMBER_FALIED: 'VERIFY_NUMBER_FALIED',
    VERIFY_NUMBER_END: 'VERIFY_NUMBER_END',

    RESEND_CODE_START: 'RESEND_CODE_START',
    RESEND_CODE_SUCEESS: 'RESEND_CODE_SUCEESS',
    RESEND_CODE_FAILED: 'RESEND_CODE_FAILED',
    RESEND_CODE_END: 'RESEND_CODE_END',

    GET_ALL_USERS_START: 'GET_ALL_USERS_START',
    GET_ALL_USERS_SUCCESS: 'GET_ALL_USERS_SUCCESS',
    GET_ALL_USERS_FAILED: 'GET_ALL_USERS_FAILED',
    GET_ALL_USERS_END: 'GET_ALL_USERS_END',

    GET_ALL_BUYERS_START: 'GET_ALL_BUYERS_START',
    GET_ALL_BUYERS_SUCCESS: 'GET_ALL_BUYERS_SUCCESS',
    GET_ALL_BUYERS_FAILED: 'GET_ALL_BUYERS_FAILED',
    GET_ALL_BUYERS_END: 'GET_ALL_BUYERS_END',

    GET_A_USERS_START: 'GET_A_USERS_START',
    GET_A_USERS_SUCCESS: 'GET_A_USERS_SUCCESS',
    GET_A_USERS_END: 'GET_A_USERS_END',
    GET_A_USERS_FAILED: 'GET_A_USERS_FAILED',

    ADD_A_USERS_START: 'ADD_A_USERS_START',
    ADD_A_USERS_SUCCESS: 'ADD_A_USERS_SUCCESS',
    ADD_A_USERS_END: 'ADD_A_USERS_END',
    ADD_A_USERS_FAILED: 'ADD_A_USERS_FAILED',

    UPDATE_A_USERS_START: 'UPDATE_A_USERS_START',
    UPDATE_A_USERS_SUCCESS: 'UPDATE_A_USERS_SUCCESS',
    UPDATE_A_USERS_END: 'UPDATE_A_USERS_END',
    UPDATE_A_USERS_FAILED: 'UPDATE_A_USERS_FAILED',

    DELETE_A_USERS_START: 'DELETE_A_USERS_START',
    DELETE_A_USERS_SUCCESS: 'DELETE_A_USERS_SUCCESS',
    DELETE_A_USERS_END: 'DELETE_A_USERS_END',
    DELETE_A_USERS_FAILED: 'DELETE_A_USERS_FAILED',

    UPDATE_A_USER_PROFILE_START: 'UPDATE_A_USER_PROFILE_START',
    UPDATE_A_USER_PROFILE_SUCCESS: 'UPDATE_A_USER_PROFILE_SUCCESS',
    UPDATE_A_USER_PROFILE_END: 'UPDATE_A_USER_PROFILE_END',
    UPDATE_A_USER_PROFILE_FAILED: 'UPDATE_A_USER_PROFILE_FAILED',

    GET_A_USER_BY_TOKEN_START: 'GET_A_USER_BY_TOKEN_START',
    GET_A_USER_BY_TOKEN_SUCCESS: 'GET_A_USER_BY_TOKEN_SUCCESS',
    GET_A_USER_BY_TOKEN_FAILED: 'GET_A_USER_BY_TOKEN_FAILED',
    GET_A_USER_BY_TOKEN_END: 'GET_A_USER_BY_TOKEN_END',

    DECREASE_UN_SEEN_ANNOUNCEMENT_START: 'DECREASE_UN_SEEN_ANNOUNCEMENT_START',
    UPDATE_IS_NEW_ORDER_TO_FALSE_START: 'UPDATE_IS_NEW_ORDER_TO_FALSE_START',
    UPDATE_IS_NEW_TICKET_TO_FALSE_START: 'UPDATE_IS_NEW_TICKET_TO_FALSE_START',
}
